import AlarmOnIcon from '@material-ui/icons/AlarmOn';
export const AutomaticTaskIcon = AlarmOnIcon;

